import { render } from "./PopUp.vue?vue&type=template&id=7e93a9f2&ts=true"
import script from "./PopUp.vue?vue&type=script&lang=ts"
export * from "./PopUp.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__